module.exports = __webpack_public_path__ + "img/banner.8149d2a0.png";